<template>
  <van-popup :show="show" round position="bottom" :style="{ height: '50%' }" @update:show="emit('update:show', $event)">
    <van-nav-bar :title="title" left-arrow @click-left="emit('update:show', false)" />
    <div class="preset-grid">
      <van-grid :column-num="2">
        <van-grid-item v-for="(preset, name) in presets" :key="name" @click="selectPreset(preset.value)">
          <van-button :type="currentTempo === preset.value ? 'primary' : 'default'" block>
            <template #default>
              <div class="preset-name">{{ t(`metronome.tempo.presets.${name}`) }}</div>
              <div class="preset-value">{{ preset.value }} BPM</div>
            </template>
          </van-button>
        </van-grid-item>
      </van-grid>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  show: boolean
  title: string
  currentTempo: number
  presets: Record<string, { value: number }>
}>()

const emit = defineEmits<{
  'update:show': [value: boolean]
  'select': [value: number]
}>()

// 使用 vue-i18n 的 t，语言切换时响应式更新
const { t } = useI18n()

function selectPreset(value: number) {
  emit('select', value)
  emit('update:show', false)
}
</script>

<style scoped>
.preset-name {
  font-weight: 500;
  margin-bottom: 4px;
}

.preset-value {
  font-size: 0.9em;
  opacity: 0.8;
}
</style>
